import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_BRAND_REQUEST = 'Brand/FETCH_BRAND_REQUEST'
const FETCH_BRAND_SUCCESS = 'Brand/FETCH_BRAND_SUCCESS'
const FETCH_BRAND_FAILURE = 'Brand/FETCH_BRAND_FAILURE'

const FETCH_BRAND_BY_ID_REQUEST = 'Brand/FETCH_BRAND_BY_ID_REQUEST'
const FETCH_BRAND_BY_ID_SUCCESS = 'Brand/FETCH_BRAND_BY_ID_SUCCESS'
const FETCH_BRAND_BY_ID_FAILURE = 'Brand/FETCH_BRAND_BY_ID_FAILURE'

const FETCH_BRAND_HERO_REQUEST = 'Brand/FETCH_BRAND_HERO_REQUEST'
const FETCH_BRAND_HERO_SUCCESS = 'Brand/FETCH_BRAND_HERO_SUCCESS'
const FETCH_BRAND_HERO_FAILURE = 'Brand/FETCH_BRAND_HERO_FAILURE'

const CREATE_BRAND_REQUEST = 'Brand/CREATE_BRAND_REQUEST'
const CREATE_BRAND_SUCCESS = 'Brand/CREATE_BRAND_SUCCESS'
const CREATE_BRAND_FAILURE = 'Brand/CREATE_BRAND_FAILURE'

const UPDATE_BRAND_REQUEST = 'Brand/UPDATE_BRAND_REQUEST'
const UPDATE_BRAND_SUCCESS = 'Brand/UPDATE_BRAND_SUCCESS'
const UPDATE_BRAND_FAILURE = 'Brand/UPDATE_BRAND_FAILURE'

const DELETE_BRAND_REQUEST = 'Brand/DELETE_BRAND_REQUEST'
const DELETE_BRAND_SUCCESS = 'Brand/DELETE_BRAND_SUCCESS'
const DELETE_BRAND_FAILURE = 'Brand/DELETE_BRAND_FAILURE'

const SAVE_BRAND_BARCODE_REQUEST = 'Brand/SAVE_BRAND_BARCODE_REQUEST'
const SAVE_BRAND_BARCODE_SUCCESS = 'Brand/SAVE_BRAND_BARCODE_SUCCESS'
const SAVE_BRAND_BARCODE_FAILURE = 'Brand/SAVE_BRAND_BARCODE_FAILURE'

const SAVE_BRAND_SETTING_REQUEST = 'Brand/SAVE_BRAND_SETTING_REQUEST'
const SAVE_BRAND_SETTING_SUCCESS = 'Brand/SAVE_BRAND_SETTING_SUCCESS'
const SAVE_BRAND_SETTING_FAILURE = 'Brand/SAVE_BRAND_SETTING_FAILURE'

const SAVE_BRAND_MATERIAL_REQUEST = 'Brand/SAVE_BRAND_MATERIAL_REQUEST'
const SAVE_BRAND_MATERIAL_SUCCESS = 'Brand/SAVE_BRAND_MATERIAL_SUCCESS'
const SAVE_BRAND_MATERIAL_FAILURE = 'Brand/SAVE_BRAND_MATERIAL_FAILURE'

const DELETE_BRAND_MATERIAL_REQUEST = 'Brand/DELETE_BRAND_MATERIAL_REQUEST'
const DELETE_BRAND_MATERIAL_SUCCESS = 'Brand/DELETE_BRAND_MATERIAL_SUCCESS'
const DELETE_BRAND_MATERIAL_FAILURE = 'Brand/DELETE_BRAND_MATERIAL_FAILURE'

const SAVE_BRAND_GUIDE_ITEM_REQUEST = 'Brand/SAVE_BRAND_GUIDE_ITEM_REQUEST'
const SAVE_BRAND_GUIDE_ITEM_SUCCESS = 'Brand/SAVE_BRAND_GUIDE_ITEM_SUCCESS'
const SAVE_BRAND_GUIDE_ITEM_FAILURE = 'Brand/SAVE_BRAND_GUIDE_ITEM_FAILURE'

const SAVE_BRAND_HERO_REQUEST = 'Brand/SAVE_BRAND_HERO_REQUEST'
const SAVE_BRAND_HERO_SUCCESS = 'Brand/SAVE_BRAND_HERO_SUCCESS'
const SAVE_BRAND_HERO_FAILURE = 'Brand/SAVE_BRAND_HERO_FAILURE'

const UPDATE_BARCODE_PRODUCT_REQUEST = 'Brand/UPDATE_BARCODE_PRODUCT_REQUEST'
const UPDATE_BARCODE_PRODUCT_SUCCESS = 'Brand/UPDATE_BARCODE_PRODUCT_SUCCESS'
const UPDATE_BARCODE_PRODUCT_FAILURE = 'Brand/UPDATE_BARCODE_PRODUCT_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  brandList: [],
  brandObj: {},
  brandHeroList: []
}

// Default Reducer
const brand = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandList: action.payload
      }
    case FETCH_BRAND_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRAND_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandObj: action.payload
      }
    case FETCH_BRAND_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRAND_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandHeroList: action.payload
      }
    case FETCH_BRAND_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BRAND_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BRAND_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BRAND_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRAND_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRAND_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRAND_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BRAND_BARCODE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BRAND_BARCODE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BRAND_BARCODE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BRAND_SETTING_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BRAND_SETTING_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BRAND_SETTING_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BRAND_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BRAND_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BRAND_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BRAND_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BRAND_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BRAND_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BRAND_GUIDE_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BRAND_GUIDE_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BRAND_GUIDE_ITEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BRAND_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BRAND_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BRAND_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case UPDATE_BARCODE_PRODUCT_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case UPDATE_BARCODE_PRODUCT_SUCCESS:
        return {
          ...state,
          isLoading: false
        }
      case UPDATE_BARCODE_PRODUCT_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
    default:
      return state
  }
}

export default brand

// Action Creators
export const fetchBrandList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_REQUEST
      })

      const response = await API.get(EndPoints.BRAND)
      dispatch({
        type: FETCH_BRAND_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_FAILURE
      })
    }
  }
}

export const fetchBrandById = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_BY_ID_REQUEST
      })

      const response = await API.get(EndPoints.BRAND + `/${id}`)
      dispatch({
        type: FETCH_BRAND_BY_ID_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_BY_ID_FAILURE
      })
    }
  }
}

export const fetchBrandHero = (brandId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_HERO_REQUEST
      })

      const response = await API.get(EndPoints.BRAND + `/hero/${brandId}`)
      dispatch({
        type: FETCH_BRAND_HERO_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_HERO_FAILURE
      })
    }
  }
}

export const createBrand = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BRAND_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.BRAND+ `/user`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_BRAND_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BRAND_FAILURE
      })
    }
  }
}

export const updateBrand = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRAND_REQUEST
      })

      await API.put(EndPoints.BRAND, data)
      dispatch({
        type: UPDATE_BRAND_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRAND_FAILURE
      })
    }
  }
}

export const updateBarcodeProduct = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BARCODE_PRODUCT_REQUEST
      })

      await API.put(EndPoints.BRAND + `/updateBarcodeProduct`, data)
      dispatch({
        type: UPDATE_BARCODE_PRODUCT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}

export const saveBrandBarcode = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BRAND_BARCODE_REQUEST
      })

      await API.post(EndPoints.BRAND + `/saveBarcodeProduct`, data)
      dispatch({
        type: SAVE_BRAND_BARCODE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_BRAND_BARCODE_FAILURE
      })
    }
  }
}

export const saveBrandSetting = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BRAND_SETTING_REQUEST
      })

      await API.post(EndPoints.BRAND + `/setting`, data)
      dispatch({
        type: SAVE_BRAND_SETTING_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_BRAND_SETTING_FAILURE
      })
    }
  }
}

export const saveBrandMaterial = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BRAND_MATERIAL_REQUEST
      })

      await API.post(EndPoints.BRAND + `/saveMaterial`, data)
      dispatch({
        type: SAVE_BRAND_MATERIAL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_BRAND_MATERIAL_FAILURE
      })
    }
  }
}

export const deleteBrand = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRAND_REQUEST
      })

      await API.delete(EndPoints.BRAND + `/${id}`)
      dispatch({
        type: DELETE_BRAND_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRAND_FAILURE
      })
    }
  }
}

export const deleteBrandMaterial = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRAND_MATERIAL_REQUEST
      })

      await API.post(EndPoints.BRAND + `/removeMaterial`, data)
      dispatch({
        type: DELETE_BRAND_MATERIAL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRAND_MATERIAL_FAILURE
      })
    }
  }
}

export const saveBrandGuideItem = (data, barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BRAND_GUIDE_ITEM_REQUEST
      })

      await API.post(EndPoints.BRAND + `/saveGuideItem/${barcodeId}`, data)
      dispatch({
        type: SAVE_BRAND_GUIDE_ITEM_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_BRAND_GUIDE_ITEM_FAILURE
      })
    }
  }
}

export const saveBrandHero = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BRAND_HERO_REQUEST
      })

      await API.post(EndPoints.BRAND + `/hero`, data)
      dispatch({
        type: SAVE_BRAND_HERO_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_BRAND_HERO_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/brand.js